import React from "react";

const Button = ({ text, className = "", ...props }) => {
  return (
    <button
      className={`bg-[#66944b] hover:bg-[#FFFFFF] text-[#ffffff] hover:text-[#66944b] border-2 border-[#effbf5] hover:border-[#66944b] px-4 py-2 rounded-lg flex gap-2 items-center text-lg sm:text-xl lg:text-lg font-semibold  ${className}`}
      {...props}
    >
      {text}
    </button>
  );
};

export default Button;
